import { FraudStatementGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { config } from '@services/config';
import { queryFraudStatementsKeys } from './keys';

export const useGetFraudStatement = (fraudStatementId?: string | null) => {
  const client = useClient();

  const result = useQuery<FraudStatementGetResponse, Error>({
    ...config,
    queryKey: queryFraudStatementsKeys.byId(fraudStatementId ?? undefined),
    queryFn: () => client.get(`fraud-statement/${fraudStatementId}`).json<FraudStatementGetResponse>(),
    enabled: !!fraudStatementId,
  });

  return { ...result, fraudStatement: result.data };
};
